import { MessageCircle } from "lucide-react";

const WHATSAPP_NUMBER = "919054555644";
const WHATSAPP_MESSAGE =
  "Hi! I'm interested in Get Easy Statement. Please share more details.";

export const WhatsAppButton = () => {
  const href = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
    WHATSAPP_MESSAGE
  )}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-btn"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-20 right-6 sm:bottom-6 z-40 group"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-60 animate-ping" />
      <span className="relative flex items-center gap-2 pl-4 pr-5 py-3 rounded-full bg-[#25D366] text-green-950 shadow-lg hover:bg-[#1ebe57] transition-colors">
        <MessageCircle size={20} strokeWidth={2.5} />
        <span className="hidden sm:inline font-semibold text-sm">
          Chat on WhatsApp
        </span>
      </span>
    </a>
  );
};
